module.exports = __webpack_public_path__ + "static/media/08_disable_Severe.e83e1862.svg";